import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { reduxForm, initialize, destroy, propTypes } from 'redux-form'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { CheckboxField, FieldError } from 'components/forms'
import { Button } from 'components/util'
import styles from './_consentsRequired.css'
import { Title, SectionContent, PrivacyWrapper } from '../../util'
import * as bootupSelectors from 'services/bootup/selectors'

export const FORM_NAME = 'consentsRequired'

const validate = () => {
  const errors = {}
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class ConsentsRequiredForm extends Component {

  static propTypes = {
    ...propTypes,
    accountPortalRoot: PropTypes.string,
    intl: PropTypes.object,
    initialize: PropTypes.func,
    consentlist: PropTypes.array,
    handleSubmit: PropTypes.func,
    isNewUser: PropTypes.bool,
  }

  renderConsentItem (item) {
    return (
      <div>
        <h1>{item.title}</h1>
        <p>{item.contentSummary}</p>
        <a href={item.contentUrl} target='_blank' rel='noopener noreferrer'>
          <FormattedMessage
            id='privacy_center.consents.consentsrequired.learnmore'
            defaultMessage='Learn More'
          />
        </a>
      </div>
    )
  }

  render () {
    const { accountPortalRoot, consentlist, handleSubmit, isNewUser, error } = this.props
    const termsLink = `${accountPortalRoot}/terms-and-conditions`
    const privacyLink = `${accountPortalRoot}/privacy`
    const affiliatesLink = `${accountPortalRoot}/privacy#who-we-are`
    return (
      <PrivacyWrapper>
        <SectionContent>
          <FormattedMessage
            id='privacy_center.consents.consentsrequired.understandterms'
            defaultMessage={'We want you to understand how we collect and use your information.'}
          />
        </SectionContent>
        <Title>
          <FormattedMessage
            id='privacy_center.consents.consentsrequired.headerinfo'
            defaultMessage='To Continue, Please read and accept the following.'
          />
        </Title>
        <SectionContent>
          <FormattedMessage
            id='privacy_center.consents.consentsrequired.withdraw'
            defaultMessage='You can withdraw these consents at any time.'
          />
        </SectionContent>
        <form method='post' onSubmit={handleSubmit}>
          <div>
            {
              consentlist ? consentlist.map(item => {
                return (
                  <div key={item.id}>
                    <hr />
                    <CheckboxField
                      name={item.id}
                      className={styles.consentCheckField}
                      labelComponent={this.renderConsentItem(item)}
                      inputIconContainerClassName={styles.checkFieldIconContainer}
                    />
                  </div>
                )
              }) : null
            }
          </div>
          <div className={styles.consentAffiliates}>
            <FormattedHTMLMessage
              id='privacy_center.terms.ua_affiliates'
              defaultMessage={'About <a href="{ affiliatesLink }" target="_blank">Under Armour, Inc. and its affiliates</a>.'}
              values={ {
                affiliatesLink,
              } }
            />
          </div>
          <hr />
          <div className={styles.tosFinePrint}>
            <FormattedHTMLMessage
              id='privacy_center.privacy_and_terms'
              defaultMessage={'<a href="{ privacyLink }" target="_blank">Privacy Policy</a> & <a href="{ termsLink }" target="_blank">Terms of Use</a>.'}
              values={ {
                termsLink,
                privacyLink,
              } }
            />
          </div>
          {error ?
            <FieldError
              showError={!!error}
              className={styles.fieldError}
              errorComponent={(<FormattedMessage
                id='privacy_center.consents.consentsrequired.error.consents_required'
                defaultMessage={'{ error }'}
                values={ { error } }
              />)}
            />
          : null}
          <div>
            {
              isNewUser ? <Button
                el='button'
                type='mmr'
                size='xlarge'
                className={styles.consentButton}>
                <FormattedMessage
                  id='privacy_center.consents.consentsrequired.createaccount'
                  defaultMessage='Create Account'
                />
              </Button> :
                <Button
                  el='button'
                  type='mmr'
                  size='xlarge'
                  className={styles.consentButton}>
                  <FormattedMessage
                    id='privacy_center.consents.consentsrequired.acceptconsents'
                    defaultMessage='Accept'
                  />
                </Button>
            }
          </div>
        </form>
      </PrivacyWrapper>
    )
  }
}

export const Form = reduxForm(formOptions)(ConsentsRequiredForm)

export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)
